enum FeatureCodes {
  EmailSending = 'EMAIL.SEND',
  ProspectAdd = 'PROSPECT.ADD',
  LeadReveal = 'LEAD.REVEAL',
  LeadRevealBucket1 = 'LEAD.REVEAL.BUCKET1',
  LeadRevealBucket2 = 'LEAD.REVEAL.BUCKET2',
  EmailVerification = 'EMAIL.VERIFICATION',
  LeadRevealPhone = 'LEAD.REVEAL.PHONE',
  EmailAccountSendingMinInterval = 'EMAIL_ACCOUNT_SETTING.MIN_INTERVAL',
  EmailAccountSendingMinIntervalDifference = 'EMAIL_ACCOUNT_SETTING.MIN_INTERVAL_DIFFERENCE',
  EmailAccountSendingMaxDailySending = 'EMAIL_ACCOUNT_SETTING.MAX_DAILY_EMAIL_SENDING_LIMIT',
  ProspectMaxActive = 'PROSPECT.MAX_ACTIVE',
  InboxAnalyzerTest = 'INBOX_ANALYZER.TESTS',
  InboxAnalyzerTrigger = 'INBOX_ANALYZER.TRIGGER',
  InboxAnalyzerEmailAccountSendingDailyLimit = 'INBOX_ANALYZER.EMAIL_ACCOUNT.DAILY_LIMIT',
  InboxAnalyzerTestEmailAccounts = 'INBOX_ANALYZER.TEST_EMAIL_ACCOUNTS',
  AI_SEQUENCE_GENERATOR = 'SEQUENCE.AI_SEQUENCE_GENERATOR',
  AI_CREDITS = 'AI_CREDITS',
}

export default FeatureCodes;
